import { StandardEntity } from '@infodata-group/inf-commons';
import { Folder } from './folder';
import { SerializedCompanyPresetInterface } from '../../interface/serialized/serialized-company-preset.interface';

export class CompanyPreset extends StandardEntity {
  public createdAt = new Date();
  public updatedAt = new Date();
  public folders: Folder[] = [];
  constructor(id: string, label = '') {
    super(id, label, 'label');
  }
  public override serialize(): SerializedCompanyPresetInterface {
    return {
      id: this.getId(),
      label: this.getLabel(),
      createdAt: this.createdAt.getTime(),
      updatedAt: this.updatedAt.getTime(),
      folders: this.folders.map((f) => f.serialize()),
    };
  }
}
